module.exports = __webpack_public_path__ + "static/assets/8d8df4d7d48ee5e7e216032744daa766.gif";